import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfig } from "../..";
import { DischargeLetterTextarea } from "../DischargeLetterTextarea";

export const MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS = 100;

export const DischargeLetterPneumologyFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_PNEUMOLOGY
>["sections"] = [
  {
    fields: {
      additional_diagnostic_findings: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .additionalDiagnosticFindings
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="additional_diagnostic_findings"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 14,
      },
      admission_medications: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .admissionMedication
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="admission_medications"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 9,
      },
      admission_reason: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .admissionReason
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="admission_reason"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 2,
      },
      anamnesis: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.anamnesis
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="anamnesis"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 8,
      },
      clinical_examination: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .clinicalExamination
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="clinical_examination"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 10,
      },
      concluding_remarks: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .concludingRemarks
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="concluding_remarks"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 7,
      },
      diagnoses: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.diagnoses
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="diagnoses"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 1,
      },
      discharge_medications: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .dischargeMedications
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_medications"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 6,
      },
      discharge_summary: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .dischargeSummary
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_summary"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 4,
      },
      next_provider: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .nextProvider
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="next_provider"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 13,
      },
      parameters: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.parameters
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="parameters"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 11,
      },
      prescribed_regulations: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .prescribedRegulations
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="prescribed_regulations"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 12,
      },
      recommendations: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .recommendations
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="recommendations"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 5,
      },
      therapy: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.therapy
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="therapy"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 3,
      },
    },
    position: 1,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formPneumology.sectionTitle,
  },
];
